const SLUG_DIVIDER = '-';

const getQuestionSlug = (sectionId: string, questionId: string) =>
  `${sectionId}${SLUG_DIVIDER}${questionId}`;

const getIdsFromSlug = (slug: string) => {
  // TODO: possibly find a more explicit way to either construct the slug with a
  // better delimiter, or send the questionId directly. Using a snake-case
  // sectionId in the slug can cause the questionId to be misinterpreted
  // (e.g. snake-"case"-realQuestionId)
  const [sectionId, questionId] = slug.split(SLUG_DIVIDER);
  return { sectionId, questionId };
};

export { getQuestionSlug, getIdsFromSlug, SLUG_DIVIDER };
